export const environment = {
  URL: 'https://dev-off-highway.alpha.simadvisory.com',
  KEYCLOAK_URL: 'https://auth.dev.simadvisory.com/auth',
  KEYCLOAK_REALM: 'D_SPRICED',
  KEYCLOAK_CLIENT_ID: 'D_SPRICED_Client',
};